import { useState, useMemo, useCallback, useEffect } from "react"
import styles from "./active-tournaments.module.css"
import TournamentBrowser from "./TournamentBrowser"
import TournamentFilters from "./TournamentFilters"
import { useDebounce } from "react-use"
import { api } from "@/utils/apiService"
import { toast } from "react-toastify"
import { useAuth } from "@/components/context/AuthContext"
import { useTheme } from "@/components/context/ThemeContext"


export default function ActiveTournaments() {
  const { user, token } = useAuth();
  const { theme } = useTheme();
  const [searchQuery, setSearchQuery] = useState("")
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("")
  const [sortBy, setSortBy] = useState("-maxPlayers")
  const [status, setStatus] = useState("")
  const [tournaments, setTournaments] = useState([])
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);

  useDebounce(
    () => setDebouncedSearchQuery(searchQuery),
    700,
    [searchQuery]
  )

  const fetchTournaments = useCallback(async (query, sortBy, status, newPage = 1) => {
    setLoading(true);
    try {
      let res;
      if(user?.role === "admin") {
        res = await api.get("/admin/tournaments", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            status: status,
            game: query,
            page: newPage,
            limit: 12,
            sort: sortBy,
          }
        })
      } else {
        res = await api.get("/tournaments/active", {
          params: {
            game: query,
            page: newPage,
            limit: 12,
            sort: sortBy,
          }
        })
      }

      
      if(res.data.success) {
        setTournaments(res.data.data.tournaments);
        setHasMore(res.data.data.pagination.current < res.data.data.pagination.pages)
      }
    } catch (error) {
      console.log("Error Fetching Tournaments ::", error);
      const errMssg = error?.response?.data?.message || error.message || "Error Fetching Tournaments";
      toast.error(errMssg);
    } finally {
      setLoading(false);
    }
  }, [])

  	//Handle scroll updation
	useEffect(() => {
		const handleScroll = () => {
			const bottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 200;
			if (bottom && hasMore && !loading) {
				setPage(prev => prev + 1);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [hasMore, loading]);

  useEffect(() => {
    fetchTournaments(debouncedSearchQuery, sortBy, status, page);
  }, [debouncedSearchQuery, sortBy, status, page, fetchTournaments])

  useEffect(() => {
		setTournaments([]);
		setPage(1);
		setHasMore(true);
    fetchTournaments(debouncedSearchQuery, sortBy, status, 1);
	  }, [debouncedSearchQuery]);	
  

  return (
    <main className={`${styles.allTournamentsContainer} ${theme === "dark" ? "dark" : ""}`}>
      <div className={styles.contentWrapper}>
        <TournamentFilters
          sortBy={sortBy}
          searchQuery={searchQuery}
          status={status}
          onSortChange={setSortBy}
          onSearchChange={setSearchQuery}
          onStatusChange={setStatus}
        />
        <TournamentBrowser tournaments={tournaments} isLoading={loading} />
      </div>
    </main>
  )
}
